export default __webpack_public_path__ + "static/3-7651a34b2f5938c8387d4fb71b11dc02.png";